export const categories = [
  { name: 'Обувь', nameEn: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Худи / Свитера', nameEn: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'Футболки', nameEn: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Куртки', nameEn: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Штаны / Шорты', nameEn: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Головные уборы', nameEn: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Комплекты', nameEn: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Нижнее бельё', nameEn: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Джерси', nameEn: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Аксессуары', nameEn: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Сумки', nameEn: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Ремни', nameEn: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Парфюмерия', nameEn: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Разное', nameEn: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

export const featuredProducts = [
  {
    id: 1,
    name: 'Nike Air Force 1 Premium',
    desc: 'Белые кроссовки премиум',
    price: '8,500 ₽',
    image: 'https://readdy.ai/api/search-image?query=Premium%20white%20Nike%20Air%20Force%201%20sneakers%20on%20clean%20cream%20marble%20surface%2C%20soft%20natural%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20side%20angle%20view%2C%20warm%20neutral%20background%2C%20editorial%20quality%2C%20high%20detail%2C%20subtle%20shadows%2C%20fresh%20aesthetic%2C%208k%20resolution%20style&width=400&height=400&seq=yoybuy-prod-01&orientation=squarish',
  },
  {
    id: 2,
    name: 'Adidas Originals Hoodie',
    desc: 'Чёрный худи с логотипом',
    price: '5,200 ₽',
    image: 'https://readdy.ai/api/search-image?query=Black%20Adidas%20Originals%20hoodie%20folded%20neatly%20on%20light%20beige%20linen%20fabric%20background%2C%20soft%20diffused%20daylight%2C%20minimalist%20flat%20lay%20product%20photography%2C%20clean%20composition%2C%20warm%20neutral%20tones%2C%20editorial%20style%2C%20high%20detail%20texture%20visible&width=400&height=400&seq=yoybuy-prod-02&orientation=squarish',
  },
  {
    id: 3,
    name: 'Balenciaga T-Shirt',
    desc: 'Оверсайз футболка',
    price: '12,800 ₽',
    image: 'https://readdy.ai/api/search-image?query=Oversized%20white%20designer%20t%20shirt%20draped%20on%20wooden%20hanger%20against%20cream%20wall%2C%20soft%20natural%20light%20from%20window%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20aesthetic%2C%20warm%20neutral%20background%2C%20editorial%20quality%2C%20high%20detail%20fabric%20texture&width=400&height=400&seq=yoybuy-prod-03&orientation=squarish',
  },
  {
    id: 4,
    name: 'Stone Island Jacket',
    desc: 'Куртка с патчем',
    price: '18,900 ₽',
    image: 'https://readdy.ai/api/search-image?query=Navy%20Stone%20Island%20jacket%20with%20badge%20displayed%20on%20minimalist%20stand%2C%20soft%20studio%20lighting%20on%20cream%20backdrop%2C%20clean%20product%20photography%2C%20warm%20neutral%20tones%2C%20editorial%20fashion%20style%2C%20high%20detail%2C%20subtle%20shadows&width=400&height=400&seq=yoybuy-prod-04&orientation=squarish',
  },
  {
    id: 5,
    name: 'Cargo Pants Relaxed',
    desc: 'Свободные карго штаны',
    price: '4,600 ₽',
    image: 'https://readdy.ai/api/search-image?query=Khaki%20cargo%20pants%20laid%20flat%20on%20light%20wooden%20surface%2C%20soft%20natural%20daylight%2C%20minimalist%20product%20photography%2C%20clean%20composition%2C%20warm%20neutral%20background%2C%20editorial%20style%2C%20high%20detail%20fabric%20texture%20visible&width=400&height=400&seq=yoybuy-prod-05&orientation=squarish',
  },
];